export const PREPARE_STATE_COPY = 'PREPARE_STATE_COPY';
export const ROLLBACK_APP_STATE_FOR_SWITCH_VEHICLE = 'ROLLBACK_APP_STATE_FOR_SWITCH_VEHICLE';
